// dependencies
import React, { useEffect } from 'react';
import { SubmitUserDetailsSuccess } from 'ouisys-engine/dist/reducers/creditCardFlow/CreditCardTypes';
import { tracker } from 'ouisys-engine/dist/reducers/strategy';
import { Link } from 'ouisys-component-library';

// local
import { injectIntl, Translate } from '../../localization/index';

const CreditCardStep = ({ gatewayUrl }: SubmitUserDetailsSuccess) => {
  useEffect(() => {
    if (typeof window != 'undefined') {
      tracker.advancedInFlow(
        'tallyman.v1-credit-card',
        'click',
        { gatewayUrl }
      );
      // window.location.href = gatewayUrl;
    }
  }, []);

  return (
    <div className="instructions">
      <Link href={gatewayUrl}>
        <Translate id="continue" defaultMessage="Continue" />
      </Link>
    </div>
  );
};

export default injectIntl(CreditCardStep);
